if (!customElements.get('klaviyo-notify')) {
  class KlaviyoNotify extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.companyId = 'VZaz68';
      this.variantInput = this.form.querySelector('input[name="variant"]');
      this.emailInput = this.querySelector('input[type="email"]');
      this.submitBtn = this.form.querySelector('button[type="submit"]');

      this.eventListeners();
    }

    eventListeners() {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.emailInput.addEventListener('input', () => this.hideMessages());
    }

    updateVariantId(id, available) {
      if (!this.variantInput) return;

      this.variantInput.value = id;
      this.toggle(available);
      this.resetForm();
    }

    toggle(available) {
      this.classList.toggle('hidden', available);
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const formData = new FormData(this.form);
      const variant = formData.get('variant');
      const email = formData.get('email');

      if (!this.validateEmail(email)) return this.showMessage('error-email'), false;
      const data = this.getBackInStockData({ email, variant });

      this.sendRequest(data);
    }

    sendRequest(data) {
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`, data)
        .then((response) => {
          if (response.status === 202) this.handleSuccess();
          else this.showMessage('error');
        })
        .catch((e) => {
          console.error(e);
          this.showMessage('error');
        });
    }

    getBackInStockData({ email, variant } = {}) {
      return {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-06-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: '' + email,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variant,
                },
              },
            },
          },
        }),
      };
    }

    validateEmail(email) {
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    }

    showMessage(eventName) {
      this.hideMessages();
      this.querySelector('.notify-message__' + eventName).classList.remove('hidden');
    }

    hideMessages() {
      this.querySelectorAll("[class*=notify-message__]").forEach(message => message.classList.add('hidden'))
    }

    handleSuccess() {
      this.submitBtn.setAttribute('disabled', '');
      this.submitBtn.getAttribute('data-success-text') && (this.submitBtn.innerHTML = this.submitBtn.getAttribute('data-success-text'));
      this.showMessage('success');
    }

    resetForm() {
      this.hideMessages();
      this.submitBtn.removeAttribute('disabled', '');
      this.submitBtn.innerHTML = this.submitBtn.getAttribute('data-submit-text');
    }
  }

  customElements.define('klaviyo-notify', KlaviyoNotify);
}
